<div class="row">
    <div class="col-3">
        <div class="card">
            <div class="card-body p-5">

                <div class="my-4">

                    <h2 class="text-center mb-5">Imposta Operazione</h2>
                    <form [formGroup]="operazione">
                        <div *ngIf="lottiPrimaOperazione" class="md-form">
                            <mdb-select placeholder="Choose your option" label="Numero Lotti Primo Livello"
                                [formControl]="lotti">
                                <mdb-option *ngFor="let lotto of lottiPrimaOperazione" [value]="lotto.value">
                                    {{ lotto.label }}</mdb-option>
                            </mdb-select>
                        </div>

                        <div class="md-form">
                            <input type="text" id="numeroOperazioni" class="form-control" [formControl]="numOp"
                                mdbInput />
                            <label for="numeroOperazioni">Numero Livelli</label>
                        </div>
                        <div class="md-form">
                            <input type="text" id="stepOp" [formControl]="stepOp" class="form-control" mdbInput />
                            <label for="stepOp">Numero punti tra livelli</label>
                        </div>
                        <div class="row my-n4">
                            <div class="col">
                                <div class="md-form">
                                    <input type="text" id="stopLoss" [formControl]="stopL" class="form-control"
                                        mdbInput />
                                    <label for="stopLoss">Stop Loss</label>
                                </div>
                            </div>
                            <div class="col">
                                <div class="md-form">
                                    <input type="text" id="trail" [formControl]="trailForm" class="form-control"
                                        mdbInput />
                                    <label for="trail">Trail</label>
                                </div>
                            </div>
                        </div>
                        <div class="md-form">
                            <input type="text" id="profit" [formControl]="profit" class="form-control" mdbInput />
                            <label for="profit">Profit</label>
                        </div>
                        <div class="row d-flex align-items-center">
                            <!-- <div class="col">
                            <mdb-checkbox (change)="check()" [formControl]="checkLVL"> Punto jump trail: </mdb-checkbox>
                        </div> -->
                            <div class="col">
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value=""
                                        id="checkLVL" (change)="check()" [formControl]="checkLVL" />
                                    <label class="form-check-label" for="checkLVL">
                                        Punto jump trail: 
                                    </label>
                                </div>
                            </div>
                            <div class="col"><a mdbTooltip="Raggiunti i punti specificati di profitto,
                        tutti gli Stop Loss vengono automaticamente spostato al primo livello di operazione"
                                    placement="top">
                                    <i class="fas fa-question-circle"></i>
                                </a></div>
                            <div class="col">

                                <div class="md-form">
                                    <input type="text" id="lvlSL" ngDefaultControl [formControl]="lvlStopLoss"
                                        name="lvlStopLoss" class="form-control" mdbInput />
                                    <label for="lvlSL"></label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <!--Body-->

                    <div class="text-center mb-3">
                        <button (click)="analizza()" type="button" mdbBtn gradient="blue" block="true" rounded="true"
                            class="z-depth-1a waves-light" mdbWavesEffect>
                            Analizza
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <!-- <div class="col-9" *ngIf="listaSSL.length">
        <div style="display: block">
            <canvas mdbChart [labels]="chartLabels" id="grafico" [type]="'line'" [datasets]="chartData" [options]="chartOptions" >
            </canvas>
        </div>
    </div> -->
    </div>